import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiPhone, FiClock, FiLink, FiAlertCircle } from 'react-icons/fi';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminCalls = () => {
    const [calls, setCalls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCalls();
    }, []);

    const fetchCalls = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            const res = await axios.get(`${API_URL}/admin/calls`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCalls(res.data.calls);
        } catch (err) {
            console.error('Failed to fetch call logs', err);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return 'var(--success)';
            case 'failed': return 'var(--danger)';
            case 'no-answer': return '#94a3b8';
            default: return 'var(--primary)';
        }
    };

    if (loading) return <div>Loading Call Logs...</div>;

    return (
        <div className="animate-fade">
            <h1 style={{ marginBottom: '2rem' }}>Call Logs</h1>

            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: 'rgba(255,255,255,0.05)' }}>
                            <th style={{ padding: '1.25rem' }}>Time</th>
                            <th style={{ padding: '1.25rem' }}>User</th>
                            <th style={{ padding: '1.25rem' }}>Direction</th>
                            <th style={{ padding: '1.25rem' }}>Duration</th>
                            <th style={{ padding: '1.25rem' }}>Minutes Charged</th>
                            <th style={{ padding: '1.25rem' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {calls.map((call) => (
                            <tr key={call._id} style={{ borderBottom: '1px solid var(--border)' }}>
                                <td style={{ padding: '1.25rem', fontSize: '0.875rem' }}>
                                    {new Date(call.createdAt).toLocaleString()}
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <div style={{ fontWeight: 600 }}>{call.user?.email || 'Guest'}</div>
                                    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>To: {call.to}</div>
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>{call.direction.toUpperCase()}</span>
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    {Math.floor(call.duration / 60)}m {call.duration % 60}s
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <div style={{ fontWeight: 700 }}>
                                        {call.minutes_charged ? `${call.minutes_charged} min` : (call.cost ? `$${call.cost.toFixed(2)}` : '0 min')}
                                    </div>
                                </td>
                                <td style={{ padding: '1.25rem' }}>
                                    <span style={{
                                        padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 700,
                                        background: `${getStatusColor(call.status)}20`,
                                        color: getStatusColor(call.status)
                                    }}>
                                        {call.status?.toUpperCase() || 'UNKNOWN'}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminCalls;
